<template>
    <div class="sch_condition_wrap">
        <div class="left">
            <!-- <div class="select_tab_box _280">
                <div class="selected_tab" @click="state.showType = !state.showType">
                    <span>{{ state.nameType }}</span>
                </div>
                <div class="tab_option" :class="[state.showType ? 'show' : '']">
                    <button type="button" @click.passive="changeType(0)">전체</button>
                    <button type="button" @click="changeType(1)">반성매매 시민활동</button>
                    <button type="button" @click="changeType(2)">캠페인·이벤트</button>
                </div>
            </div> -->
        </div>
        <div class="right">
            <div class="info_box">
                <div>
                    총 게시물
                    <span class="col_blue">{{ CommonUtils.numberFormat(state.sum) }}개</span>
                </div>
                <div>
                    총 신청자
                    <span class="col_blue">{{ CommonUtils.numberFormat(state.sumApply) }}명</span>
                </div>
                <div>
                    총 선발인원
                    <span class="col_blue">{{ CommonUtils.numberFormat(state.sumPick) }}명</span>
                </div>
            </div>
        </div>
    </div>
    <div class="common_table custom_scroll">
        <table>
            <colgroup>
                <!-- <col style="width: 270px" /> -->
                <col />
                <!-- <col style="width: 200px" /> -->
                <col style="width: 200px" />
                <col style="width: 150px" />
                <col style="width: 150px" />
            </colgroup>
            <thead class="left">
                <tr>
                    <!-- <th>게시판 이름</th> -->
                    <th>게시물 제목</th>
                    <!-- <th>게시일자</th> -->
                    <th>진행기간</th>
                    <th>신청인원</th>
                    <th>당첨인원</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="state.list.length > 0">
                    <tr v-for="(item, idx) in state.list" :key="idx">
                        <!-- <td>{{ item.type === 1 ? "반성매매 시민활동" : "캠페인·이벤트" }}</td> -->
                        <td>{{ item.title }}</td>
                        <!-- <td>{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td> -->
                        <td>
                            {{ CommonUtils.dateFormat(new Date(item.recruitStartDate), ".", false) }} ~
                            {{ CommonUtils.dateFormat(new Date(item.recruitEndDate), ".", false) }}
                        </td>
                        <td>{{ CommonUtils.numberFormat(item.applyCnt) }}명</td>
                        <td>{{ CommonUtils.numberFormat(item.cntWin) }}명</td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="5">
                        <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                    </td>
                </tr>
            </tbody>
        </table>
        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            @onPaging="handlePageChange"
        ></PageBtn>
    </div>
</template>

<script lang="ts" config>
    import { userStore, globalStore, reactive, watch, apiService, onMounted, types, PageBtn, CommonUtils } from "@/BaseComponent";
    import { ResBoardVOForApi } from "@/types";

    export default {
        props: {
            startDate: { type: String, required: true },
            endDate: { type: String, required: true },
        },
        components: { PageBtn },
        setup(props: any) {
            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                list: [] as Array<ResBoardVOForApi>,
                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                type: 0 | 1 | 2,
                showType: false as boolean,
                nameType: "전체" as string,

                sum: 0 as number,
                sumApply: 0 as number,
                sumPick: 0 as number,
            });

            onMounted(() => {
                state.startDate = props.startDate;
                state.endDate = props.endDate;

                changeType(2);
            });

            watch(props, () => {
                state.startDate = props.startDate;
                state.endDate = props.endDate;
                getList();
            });

            const changeType = (type: number) => {
                state.type = type;

                switch (state.type) {
                    case 1:
                        state.nameType = "반성매매 시민활동";
                        break;
                    case 2:
                        state.nameType = "캠페인·이벤트";
                        break;
                    default:
                        state.nameType = "전체";
                        break;
                }

                state.showType = false;
                getList();
            };

            const getList = async () => {
                const param: types.ReqBoardListForActivityManage = {
                    page: state.page,
                    size: state.size,
                    searchType: "",
                    searchText: "",
                    startDate: state.startDate,
                    endDate: state.endDate,
                    type: state.type,
                };
                const res: types.ResStatisticsForBoard = await apiService.statistics.board(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                    state.sum = res.sum;
                    state.sumApply = res.sumApply;
                    state.sumPick = res.sumPick;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                    state.sum = 0;
                    state.sumApply = 0;
                    state.sumPick = 0;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            return { state, handlePageChange, CommonUtils, changeType };
        },
    };
</script>

<style scoped>
    .tab_option.show {
        visibility: visible;
        height: auto;
        opacity: 1;
    }

    .common_table {
        overflow-y: auto !important;
    }
</style>
